import useSWR from "swr";
import type { SwrReturnType } from "~/models/Api";
import type { VendorLeasing } from "~/models/Leasing";
import { generatePath } from "~/utils/generatePath";

export const useKtLeasings = (
	leasingId: string
): SwrReturnType<VendorLeasing> => {
	const { data, mutate, error, isLoading } = useSWR<VendorLeasing>(
		generatePath("/vendors/kt_leasings/:leasing_id", {
			leasing_id: leasingId
		})
	);
	return {
		data: data ?? null,
		error,
		isLoading,
		mutate
	};
};
